import { Tag, Space, Typography, Tooltip } from "antd";
import CustomButton from "../../../components/CustomButton/Button";
import dayjs from "dayjs";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

export const getCreditLimitColumns = ({ onEdit, onRequestAgain, onViewReason }) => [
  {
    title: "Enterprise Name",
    dataIndex: "enterpriseName",
    key: "enterpriseName",
    render: (text, record) => (
      <Space direction="vertical" size={2}>
        <Text strong>{text || "-"}</Text>
        <Tag color={record.entId ? "blue" : "purple"}>
          {record.entId ? "Existing Enterprise" : "New Enterprise"}
        </Tag>
      </Space>
    ),
  },
  {
    title: "Requested Credit",
    dataIndex: "requestedCredit",
    key: "requestedCredit",
    render: (val) => (
      <Text>
        ₹{Number(val || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
      </Text>
    ),
  },
  {
    title: "Approved Credit",
    dataIndex: "approvedCredit",
    key: "approvedCredit",
    render: (val, record) =>
      record.status === "Approved" && val ? (
        <Text type="success" strong>
          ₹{Number(val).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
        </Text>
      ) : (
        <Text type="secondary">-</Text>
      ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      if (status === "Approved") {
        return <Tag color="success">Approved</Tag>;
      }
      if (status === "Rejected") {
        return <Tag color="error">Rejected</Tag>;
      }
      return <Tag color="warning">Pending</Tag>;
    },
  },
  {
    title: "Remarks / Reason",
    key: "remarksOrReason",
    render: (_, record) => {
      if (record.status === "Rejected" && record.rejectionReason) {
        return (
          <Space>
            <Text type="danger" ellipsis style={{ maxWidth: 160 }}>
              {record.rejectionReason}
            </Text>
            <Tooltip title="View full rejection reason">
              <InfoCircleOutlined
                style={{ color: "#ff4d4f", cursor: "pointer" }}
                onClick={() => onViewReason(record)}
              />
            </Tooltip>
          </Space>
        );
      }
      if (record.remarks) {
        return (
          <Text type="secondary" ellipsis style={{ maxWidth: 180 }}>
            {record.remarks}
          </Text>
        );
      }
      return <Text type="secondary">-</Text>;
    },
  },
  {
    title: "Requested Date",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (date) => (date ? dayjs(date).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "Actions",
    key: "actions",
    render: (_, record) => {
      if (record.status === "Rejected") {
        return (
          <Space size="small">
            <CustomButton
              size="small"
              type="primary"
              onClick={() => onEdit(record)}
            >
              Edit
            </CustomButton>
            {/* <CustomButton
              size="small"
              onClick={() => onRequestAgain(record)}
            >
              Request Again
            </CustomButton> */}
          </Space>
        );
      }
      if (record.status === "Approved") {
        return <Tag color="green">Limit Active</Tag>;
      }
      return <Text type="secondary">In Review</Text>;
    },
  },
];
